import React from "react";
import { useTranslation } from "react-i18next";
import Banner from "@/components/ui/banner";
import { useDealsNavigation } from "@/services/hooks/entities/deal/useDealsNavigation";

const TRANSLATION_KEY = "leads.leadView.convertedBanner";

interface Props {
  linkedDealId: string;
}

const LeadConvertedBanner: React.FC<Props> = ({ linkedDealId }) => {
  const { t } = useTranslation();
  const { navigateToDetailedView } = useDealsNavigation();

  return (
    <Banner
      variant="general"
      title={t(`${TRANSLATION_KEY}.title`)}
      buttonText={t(`${TRANSLATION_KEY}.viewDeal`)}
      onButtonClick={() => navigateToDetailedView(linkedDealId)}
      showCloseButton={true}
    />
  );
};

export default LeadConvertedBanner;
